import { filter, find, isEmpty, groupBy, findIndex, some, every, forEach, merge, findLast, size } from 'lodash';
import config from './config';
import common from './common';
import { isUndefined } from './helper-common';

const clone = require('fast-clone');
const orderToScan = ['4', '3', '2', '1', '0'];

export function createTeamData(state) {
    const { constraints, formations, newFormationId, playerPos } = state;
    const { MaxTeamValue, MaxTeamPlayers } = constraints;
    const selForm = find(formations, { CompId: newFormationId });
    let maxFormation = find(formations, { CompId: config.MAX_FORMATION_COMP_ID });
    let rawTeamData = clone(state.teamData || {});
    const playerObj = {
        id: null,
        details: {},
        isBench: false,
        isHighlighted: false,
        isCaptain: false,
        skill: null
    };
    const getInitialSkeleton = (rawTeamData, selForm, maxFormation) => {
        rawTeamData[0] = [];
        playerPos.forEach((skill, i) => {
            const key = i + 1;
            rawTeamData[key] = [];
            for (let j = 1; j <= maxFormation[skill]; j++) {
                if (selForm[skill] >= j) {
                    rawTeamData[key].push({ ...playerObj, skill: key });
                } else {
                    rawTeamData[0].push({ ...playerObj, isBench: true, skill: key });
                }
            }
        });
        rawTeamData[0] = rawTeamData[0].sort((a, b) => {
            return a.skill - b.skill;
        });
        return rawTeamData;
    };
    if (isEmpty(rawTeamData)) {
        rawTeamData.budget = MaxTeamValue;
        rawTeamData.playerCount = 0;
        rawTeamData.captainID = null;
        rawTeamData.badgeID = null;
        rawTeamData.teamName = null;
        rawTeamData.clubID = null;
        rawTeamData.playersInTeam = [];
        rawTeamData.maxPos = [
            maxFormation.GK,
            maxFormation.DEF,
            maxFormation.MID,
            maxFormation.FWD
        ];
        rawTeamData.max_playerPerTeam = MaxTeamPlayers; // Maximum number of players allowed from a team
        rawTeamData = getInitialSkeleton(rawTeamData, selForm, maxFormation);
        const highlightedSkill = getFirstPositionToHighlight(rawTeamData);
        return { ...rawTeamData, highlightedSkill };
    } else {
        let oldDataForDiff = clone(rawTeamData);
        let tempOldData = clone(rawTeamData);
        let newRawData = getInitialSkeleton(rawTeamData, selForm, maxFormation);
        const findPositionFilledJerseyAndReturn = (skill) => {
            for (let j = 0; j < tempOldData[skill].length; j++) {
                if (+tempOldData[skill][j].skill === +skill && tempOldData[skill][j].id !== null) {
                    const dataToReturn = clone(tempOldData[skill][j]);
                    tempOldData[skill][j] = { ...playerObj };
                    return dataToReturn;
                }
            }
            for (let j = 0; j < tempOldData['0'].length; j++) {
                if (+tempOldData['0'][j].skill === +skill && tempOldData['0'][j].id !== null) {
                    const dataToReturn = clone(tempOldData['0'][j]);
                    tempOldData['0'][j] = { ...playerObj };
                    return dataToReturn;
                }
            }
            return {};
        };
        const getLastEmptyPosition = (newRawData, skillIndex) => {
            for (let i = newRawData[skillIndex].length; i--;) {
                if (newRawData[skillIndex][i].id === null) {
                    return i;
                }
            }
        };
        for (let i = 0, iLen = orderToScan.length; i < iLen; i++) {
            let skillIndex = orderToScan[i];
            for (let j = 0, jLen = tempOldData[skillIndex].length; j < jLen; j++) {
                const foundJersey = tempOldData[skillIndex][j];
                if ((foundJersey.DBDetails && !canPlayerSubstitute(foundJersey))) {
                    let newIndexForCaptain = 0;
                    if (j < newRawData[skillIndex].length) {
                        newIndexForCaptain = j;
                    } else {
                        newIndexForCaptain = getLastEmptyPosition(newRawData, skillIndex);
                    }
                    const isBench = skillIndex === '0';
                    const isCaptain = foundJersey.isCaptain;
                    if (skillIndex === '0') {
                        newIndexForCaptain = findIndex(newRawData[skillIndex], (jersey) => {
                            return +jersey.skill === +foundJersey.skill && jersey.id === null;
                        });
                        newRawData[skillIndex][newIndexForCaptain] = { ...foundJersey, isCaptain, isBench };
                        tempOldData[skillIndex][j] = { ...playerObj };
                    } else {
                        newRawData[skillIndex][newIndexForCaptain] = { ...foundJersey, isCaptain, isBench };
                        tempOldData[skillIndex][j] = { ...playerObj };
                    }
                }
            }
        }
        orderToScan.forEach((positionKey) => {
            newRawData[positionKey].forEach((newJersey, jIndex) => {
                if (newJersey.id === null) {
                    let foundJersey = findPositionFilledJerseyAndReturn(newJersey.skill);
                    if (!isEmpty(foundJersey)) {
                        const isBench = positionKey === '0';
                        const isCaptain = foundJersey.isCaptain;
                        newRawData[positionKey][jIndex] = { ...foundJersey, isCaptain, isBench };
                    }
                }
            });
        });
        rawTeamData[0] = rawTeamData[0].sort((a, b) => {
            return a.skill - b.skill;
        });
        rawTeamData[0].forEach((player, index) => {
            const getPlayerIndexInBench = (playerID) => {
                return findIndex(oldDataForDiff[0], { id: playerID });
            };
            const playerOldIndexInBench = getPlayerIndexInBench(player.id);
            if (player.id && playerOldIndexInBench > -1 && playerOldIndexInBench !== index) {
                const A = clone(rawTeamData[0][index]);
                const B = clone(rawTeamData[0][playerOldIndexInBench]);
                rawTeamData[0][playerOldIndexInBench] = A;
                rawTeamData[0][index] = B;
            }
        });
        const isCaptainInBench = (teamData) => {
            return teamData[0].some(el => el.isCaptain === true);
        };
        if (isCaptainInBench(rawTeamData)) {
            const updatedTeamData = getAutoSubstitutionsApiData(rawTeamData, oldDataForDiff);
            const getSubsData = getSubstitutionsApiData(updatedTeamData);
            const newCaptainIndex = findIndex(getSubsData.SubPlayerBenchPosition, (benchPosition) => {
                return +benchPosition === 0;
            });
            if (newCaptainIndex > -1) {
                const newCaptainID = getSubsData.SubPlayerId[newCaptainIndex];
                rawTeamData.captainID = newCaptainID;
                updatePropInTeam(rawTeamData, 'isCaptain', false);
                const newCaptainObj = getPlayerByKeyFromTeamData(rawTeamData, 'id', newCaptainID);
                if (!isEmpty(newCaptainObj)) {
                    newCaptainObj.data.isCaptain = true;
                }
            }
        }
        const highlightedSkill = getFirstPositionToHighlight(newRawData);
        return { ...newRawData, highlightedSkill };
    }
}

export function addOrRemovePlayer(data, playerObj, skillId, rowIndex, playerIndex, manageTeamRawData, skillFilters) {
    const isManageTeam = common.isManageTeam();
    if (isManageTeam) {
        const configObj = { EnumMaxPositionNos: {} };
        configObj.EnumMaxPositionNos[1] = data.maxPos[0];
        configObj.EnumMaxPositionNos[2] = data.maxPos[1];
        configObj.EnumMaxPositionNos[3] = data.maxPos[2];
        configObj.EnumMaxPositionNos[4] = data.maxPos[3];
        let errorObj = {
            playersPerSkillCountExceeded: false,
            playersPerTeamCountExceeded: false,
            skill: null,
            team: null
        };
        const teamData = clone(data);
        const playerID = playerObj.Id;
        const playerIDInSkills = findIndex(teamData[skillId], player => +player.id === +playerID);
        const playerIDInBench = findIndex(teamData[0], player => +player.id === +playerID);
        var isPlayerRecoveredFromPitch = findIndex(teamData[skillId], player => +player.DBDetails.Id === +playerID);
        var isPlayerRecoveredFromBench = findIndex(teamData[0], player => +player.DBDetails.Id === +playerID);
        /**/
        const emptyIndexOfPosition = findIndex(teamData[skillId], { id: null });
        const emptyIndexOfBench = findIndex(teamData[0], { id: null, skill: skillId });
        /**/
        const isPlayerInRemovedKey = (playerID) => {
            return manageTeamRawData.playersInTeam.indexOf(playerID) > -1;
        };
        const removePlayer = (teamData, rowIndex, positionIndex) => {
            teamData.budget = +teamData.budget + +playerObj.Value;
            let wasCaptain = teamData[rowIndex][positionIndex].isCaptain;
            const playerObjFound = teamData[rowIndex][positionIndex];
            playerObjFound.id = null;
            playerObjFound.details = {};
            teamData.playerCount -= 1;
            const playerIndex = teamData.playersInTeam.indexOf(playerID);
            teamData.playersInTeam.splice(playerIndex, 1);
            updatePropInTeam(teamData, 'isHighlighted', false);
            wasCaptain && (teamData.captainID = null);
            // teamData.highlightedSkill = getNextPositionToHighlight(teamData, rowIndex, positionIndex);
            // teamData.highlightedSkill = getHighLightFromteam(teamData);
            teamData.highlightedSkill = { skill: playerObj.Skill, rowIndex: rowIndex, playerIndex: positionIndex };
        };
        const addPlayer = (teamData, newRowIndex, positionIndex) => {
            let playerCountInSkill = filter(teamData[skillId], function (O) {
                return O.id !== null;
            }).length;
            let playerCountInBench = filter(teamData[0], function (O) {
                return O.id !== null && +O.skill === +skillId;
            }).length;
            if ((playerCountInSkill + playerCountInBench) < configObj.EnumMaxPositionNos[skillId]) {
                const playersPerTeamCountExceeded = isValidateByMaxTeamPlayer(teamData, playerObj, teamData.max_playerPerTeam);
                const state = playersPerTeamCountExceeded.state;
                if (playersPerTeamCountExceeded.status) {
                    teamData.budget = +teamData.budget - +playerObj.Value;
                    let wasCaptain = teamData[newRowIndex][positionIndex].isCaptain;

                    const playerObjFound = teamData[newRowIndex][positionIndex];
                    playerObjFound.id = playerID;
                    playerObjFound.details = playerObj;
                    teamData.playerCount += 1;
                    teamData.playersInTeam.push(playerID);
                    updatePropInTeam(teamData, 'isHighlighted', false);
                    wasCaptain && (teamData.captainID = playerID);
                    if (isPlayerInRemovedKey(playerID)) {
                        const oldPosition = getPlayerPosition(playerID, manageTeamRawData);
                        const oldRowIndex = oldPosition.rowIndex;
                        const oldPositionIndex = oldPosition.playerIndex;
                        const playerFromOldPosition = clone(teamData[oldRowIndex][oldPositionIndex]);
                        const playerFromNewPosition = clone(teamData[newRowIndex][positionIndex]);
                        /*Assigning player from old position to new position*/
                        teamData[newRowIndex][positionIndex].id = playerFromOldPosition.id;
                        teamData[newRowIndex][positionIndex].details = clone(playerFromOldPosition.details);
                        /*Assigning player from new position to old position*/
                        teamData[oldRowIndex][oldPositionIndex].id = playerFromNewPosition.id;
                        teamData[oldRowIndex][oldPositionIndex].details = clone(playerFromNewPosition.details);
                    }
                    // teamData.highlightedSkill = getNextPositionToHighlight(teamData, rowIndex, ++playerIndex);
                    // teamData.highlightedSkill = getNextHighLightposition(newRowIndex, positionIndex, teamData, skillFilters.length, newRowIndex, isManageTeam);
                    teamData.highlightedSkill = { skill: playerObj.Skill, rowIndex: newRowIndex, playerIndex: positionIndex };
                }

                if (state === 'ok') {
                    errorObj.playersPerTeamCountExceeded = false;
                    errorObj.team = null;
                    errorObj.tid = playerObj.TID;
                } else if (state === 'exceed') {
                    errorObj.playersPerTeamCountExceeded = true;
                    errorObj.team = playerObj.TName;
                    errorObj.tid = playerObj.TID;
                } else if (state === 'level') {
                    errorObj.playersPerTeamCountExceeded = true;
                    errorObj.team = playerObj.TName;
                    errorObj.tid = playerObj.TID;
                }
                errorObj.state = state;
            }
        };
        if (playerIDInSkills > -1) {
            removePlayer(teamData, skillId, playerIDInSkills);
        } else if (playerIDInBench > -1) {
            removePlayer(teamData, 0, playerIDInBench);
        } else if (emptyIndexOfPosition > -1) {
            // // addPlayer(teamData, rowIndex, playerIndex);
            // // if (skillFilters.length != 1) {
            // //     // do nothing add player according to new logic of skill
            // //     addPlayer(teamData, skillId, playerIndex);
            // // } else {
            // addPlayer(teamData, skillId, playerIndex);
            // // }
            // if (isPlayerRecoveredFromPitch > -1) {
            //     addPlayer(teamData, skillId, isPlayerRecoveredFromPitch);
            // }
            // else {
            //     addPlayer(teamData, skillId, emptyIndexOfPosition);
            // }
            if (isPlayerRecoveredFromPitch > -1) {
                addPlayer(teamData, skillId, emptyIndexOfPosition);
            }
            else {
                addPlayer(teamData, skillId, emptyIndexOfPosition);
            }
        } else if (emptyIndexOfBench > -1) {
            if (isPlayerRecoveredFromBench > -1) {
                addPlayer(teamData, 0, emptyIndexOfBench);
            }
            else {
                addPlayer(teamData, 0, emptyIndexOfBench);
            }
            // addPlayer(teamData, rowIndex, playerIndex);
            // if (skillFilters.length != 1) {
            //     // do nothing add player according to new logic
            //     addPlayer(teamData, skillId, playerIndex);
            // } else {
            // addPlayer(teamData, rowIndex, playerIndex);
            // addPlayer(teamData, skillId, playerIndex);
            // }
        } else {
            errorObj.maxPlayers = configObj.EnumMaxPositionNos[skillId]
            errorObj.playersPerSkillCountExceeded = true;
            errorObj.skill = skillId;
        }
        teamData.budget = (+teamData.budget).toFixed(1);
        differentiateNewPlayers(teamData, manageTeamRawData);
        return { teamData, errorObj };
    } else {
        const configObj = { EnumMaxPositionNos: {} };
        configObj.EnumMaxPositionNos[1] = data.maxPos[0];
        configObj.EnumMaxPositionNos[2] = data.maxPos[1];
        configObj.EnumMaxPositionNos[3] = data.maxPos[2];
        configObj.EnumMaxPositionNos[4] = data.maxPos[3];
        let errorObj = {
            playersPerSkillCountExceeded: false,
            playersPerTeamCountExceeded: false,
            skill: null,
            team: null
        };
        const teamData = clone(data);
        const playerID = playerObj.Id;
        const playerIDInSkills = findIndex(teamData[skillId], player => +player.id === +playerID);
        const playerIDInBench = findIndex(teamData[0], player => +player.id === +playerID);
        /**/
        const emptyIndexOfPosition = findIndex(teamData[skillId], { id: null });
        const emptyIndexOfBench = findIndex(teamData[0], { id: null, skill: skillId });
        /**/
        const removePlayer = (teamData, skillIdentifier, positionIndex) => {
            teamData.budget = +teamData.budget + +playerObj.Value;
            let wasCaptain = teamData[skillIdentifier][positionIndex].isCaptain;
            teamData[skillIdentifier][positionIndex] = {
                id: null,
                details: {},
                isBench: +skillIdentifier === 0,
                isHighlighted: false,
                isCaptain: false,
                skill: skillId
            };
            teamData.playerCount -= 1;
            const playerIndex = teamData.playersInTeam.indexOf(playerID);
            teamData.playersInTeam.splice(playerIndex, 1);
            let lastHighlightedPosition = getHighLightFromteam(teamData);
            updatePropInTeam(teamData, 'isHighlighted', false);
            wasCaptain && (teamData.captainID = null);
            if (!isEmpty(lastHighlightedPosition)) {
                teamData.highlightedSkill = getNextPositionToHighlight(teamData, skillIdentifier, positionIndex);
            } else {
                teamData.highlightedSkill = { skill: skillIdentifier, rowIndex: skillIdentifier, playerIndex: positionIndex };;
            }

        };
        const addPlayer = (teamData, skillIdentifier, positionIndex) => {
            let playerCountInSkill = filter(teamData[skillId], function (O) {
                return O.id !== null;
            }).length;
            let playerCountInBench = filter(teamData[0], function (O) {
                return O.id !== null && +O.skill === +skillId;
            }).length;
            if ((playerCountInSkill + playerCountInBench) < configObj.EnumMaxPositionNos[skillId]) {
                const playersPerTeamCountExceeded = isValidateByMaxTeamPlayer(teamData, playerObj, teamData.max_playerPerTeam);
                const state = playersPerTeamCountExceeded.state;
                if (playersPerTeamCountExceeded.status) {

                    //check if next highlight position is avail
                    let currentHighLightPosition = getHighLightFromteam(teamData);
                    if (!isEmpty(currentHighLightPosition) && playerObj.Skill == currentHighLightPosition.skill) {
                        teamData.budget = +teamData.budget - +playerObj.Value;
                        teamData[currentHighLightPosition.rowIndex][currentHighLightPosition.playerIndex] = {
                            id: playerID,
                            details: playerObj,
                            isBench: +skillIdentifier === 0,
                            isHighlighted: false,
                            isCaptain: false,
                            skill: skillId
                        };
                        teamData.playerCount += 1;
                        teamData.playersInTeam.push(playerID);
                        updatePropInTeam(teamData, 'isHighlighted', false);
                        teamData.highlightedSkill = getNextHighLightposition(currentHighLightPosition.skill, currentHighLightPosition.playerIndex, teamData);
                    } else {
                        const pitchEmptyIndex = findIndex(teamData[playerObj.Skill], function (player) { return player.id == null; });
                        if (pitchEmptyIndex > -1) {
                            teamData.budget = +teamData.budget - +playerObj.Value;
                            teamData[playerObj.Skill][pitchEmptyIndex] = {
                                id: playerID,
                                details: playerObj,
                                isBench: +skillIdentifier === 0,
                                isHighlighted: false,
                                isCaptain: false,
                                skill: skillId
                            };
                            teamData.playerCount += 1;
                            teamData.playersInTeam.push(playerID);
                            updatePropInTeam(teamData, 'isHighlighted', false);
                            if (skillFilters.length == 1) {
                                // show the player the next highlight position
                                teamData.highlightedSkill = getNextHighLightposition(playerObj.Skill, pitchEmptyIndex, teamData);
                            } else {
                                teamData.highlightedSkill = getNextHighLightposition(playerObj.Skill, pitchEmptyIndex, teamData, skillFilters);
                            }

                        } else {
                            //cjheck for row 0 and index is available
                            const benchEmptyIndex = findIndex(teamData[0], function (player) { return player.id == null && player.skill == playerObj.Skill; });
                            if (benchEmptyIndex > -1) {
                                teamData.budget = +teamData.budget - +playerObj.Value;
                                teamData[0][benchEmptyIndex] = {
                                    id: playerID,
                                    details: playerObj,
                                    isBench: +skillIdentifier === 0,
                                    isHighlighted: false,
                                    isCaptain: false,
                                    skill: skillId
                                };
                                teamData.playerCount += 1;
                                teamData.playersInTeam.push(playerID);
                                updatePropInTeam(teamData, 'isHighlighted', false);
                                if (skillFilters.length == 1) {
                                    // show the player the next highlight position
                                    teamData.highlightedSkill = getNextHighLightposition(playerObj.Skill, benchEmptyIndex, teamData);
                                } else {
                                    teamData.highlightedSkill = getNextHighLightposition(playerObj.Skill, benchEmptyIndex, teamData, skillFilters, 0);
                                }


                            } else {
                                // all is full
                            }
                        }
                    }








                }
                if (state === 'ok') {
                    errorObj.playersPerTeamCountExceeded = false;
                    errorObj.team = null;
                    errorObj.tid = playerObj.TID;
                } else if (state === 'exceed') {
                    errorObj.playersPerTeamCountExceeded = true;
                    errorObj.team = playerObj.TName;
                    errorObj.tid = playerObj.TID;
                } else if (state === 'level') {
                    errorObj.playersPerTeamCountExceeded = true;
                    errorObj.team = playerObj.TName;
                    errorObj.tid = playerObj.TID;
                }
                errorObj.state = state;
            }
        };
        if (playerIDInSkills > -1) {
            removePlayer(teamData, skillId, playerIDInSkills);
        } else if (playerIDInBench > -1) {
            removePlayer(teamData, 0, playerIDInBench);
        } else if (emptyIndexOfPosition > -1) {
            if (skillFilters.length != 1) {
                // do nothing add player according to new logic of skill
                addPlayer(teamData, skillId, playerIndex);
            } else {
                addPlayer(teamData, rowIndex, playerIndex);
            }

        } else if (emptyIndexOfBench > -1) {
            if (skillFilters.length != 1) {
                // do nothing add player according to new logic
                addPlayer(teamData, skillId, playerIndex);
            } else {
                addPlayer(teamData, rowIndex, playerIndex);
            }

        } else {
            errorObj.playersPerSkillCountExceeded = true;
            errorObj.skill = skillId;
            errorObj.maxPlayers = configObj.EnumMaxPositionNos[skillId]
        }
        teamData.budget = (+teamData.budget).toFixed(1);
        return { teamData, errorObj };
    }
}

function isPositionAllFilled(teamData, row) {
    return every(teamData[row], player => player.id !== null);
}

function differentiateNewPlayers(teamData, oldTeamData) {
    const diffArray = getInTeamArray(teamData, oldTeamData);
    updatePropInTeam(teamData, 'isNew', false);
    diffArray.forEach(player => {
        player.isNew = true;
    });
}
//added this 
function getUpdatedPosition(teamData, rowIndex) {
    //get the skill
    let skill = teamData[rowIndex][0].skill;
    let highlightIndex = "";
    if (teamData[0]) {
        highlightIndex = findIndex(teamData[0], function (plyObj) { return plyObj.skill == skill && plyObj.id == null; });
        if (highlightIndex > -1) {
            return getNextPositionToHighlight(teamData, 0, highlightIndex);
        }
    }
}

function getNextPositionToHighlight(teamData, rowIndex, newPlayerIndex) {
    let keysToConsider = ['4', '3', '2', '1'];
    const isAllTeamFilled = () => every(orderToScan, row => every(teamData[row], player => player.id !== null));
    const isPitchTeamFilled = () => every(keysToConsider, row => every(teamData[row], player => player.id !== null));
    const possibleRow = teamData[rowIndex];
    if (possibleRow) {
        //check if previsous player had the same id
        const possiblePlayer = possibleRow[newPlayerIndex];
        // if (possiblePlayer.skill != possibleRow[newPlayerIndex - 1].skill) {
        //     return null;
        // }

        if (possiblePlayer) {
            if (possiblePlayer.id === null) {
                possiblePlayer.isHighlighted = true;
                return { skill: possiblePlayer.skill, rowIndex: rowIndex, playerIndex: newPlayerIndex };
            } else {
                if (isPositionAllFilled(teamData, rowIndex)) {
                    return getUpdatedPosition(teamData, rowIndex);
                } else {
                    return getNextPositionToHighlight(teamData, rowIndex, ++newPlayerIndex);
                }

            }
        } else {
            if (isPositionAllFilled(teamData, rowIndex)) {
                //adding code for updated squence
                // if (+rowIndex !== 1) {
                return getUpdatedPosition(teamData, rowIndex);
                // }
                // if (isPitchTeamFilled() || +rowIndex !== 1) {
                //     return getNextPositionToHighlight(teamData, --rowIndex, 0);
                // } else {
                //     return getNextPositionToHighlight(teamData, 4, 0);
                // }
                // } else {
                //     return getNextPositionToHighlight(teamData, rowIndex, 0);
            } else {
                if (rowIndex != 0) {
                    return getNextPositionToHighlight(teamData, rowIndex, 0);
                }

            }
        }
    } else {
        if (isAllTeamFilled()) {
            return {};
        } else {
            return getNextPositionToHighlight(teamData, 4, 0);
        }
    }
}

function getFirstPositionToHighlight(teamData) {
    updatePropInTeam(teamData, 'isHighlighted', false);
    let highlightPosition = {};
    orderToScan.some((key) => {
        return teamData[key].some((player, index) => {
            if (player.id === null) {
                // player.isHighlighted = true;
                highlightPosition = { skill: player.skill, rowIndex: key, playerIndex: index };
                return true;
            }
            return false;
        });
    });
    return highlightPosition;
}

function getNextHighLightposition(skill, currentIndex, teamData, skillFilter, row, isManageTeamMode) {

    if (skillFilter && skillFilter.length > 1) {

        if (row === 0) {
            let currentPlayerZeroIndex = teamData[row][currentIndex];
            return { skill: currentPlayerZeroIndex.skill, rowIndex: row, playerIndex: currentPlayerZeroIndex };
        } else {
            let currentPlayerPitchIndex = teamData[skill][currentIndex];
            return { skill: currentPlayerPitchIndex.skill, rowIndex: currentPlayerPitchIndex.skill, playerIndex: currentPlayerPitchIndex };
        }

    } else {
        let possiblePlayer = teamData[skill][currentIndex + 1];
        // also check if row position is all filled
        let oddSequenceFillerPlayer = find(teamData[skill], function (player) { return player.id == null });


        if (possiblePlayer && possiblePlayer.id == null) {
            possiblePlayer.isHighlighted = true;
            return { skill: possiblePlayer.skill, rowIndex: possiblePlayer.skill, playerIndex: currentIndex + 1 };
        } else if (oddSequenceFillerPlayer && oddSequenceFillerPlayer.id == null) {
            oddSequenceFillerPlayer.isHighlighted = true;
            return { skill: oddSequenceFillerPlayer.skill, rowIndex: oddSequenceFillerPlayer.skill, playerIndex: currentIndex + 1 };
        } else {
            //also check if player available in bench
            const benchEmptyIndex = findIndex(teamData[0], function (player) { return player.id == null && player.skill == skill; });
            if (benchEmptyIndex > -1) {
                let bechPlayer = teamData[0][benchEmptyIndex];
                bechPlayer.isHighlighted = true;
                return { skill: bechPlayer.skill, rowIndex: 0, playerIndex: benchEmptyIndex + 1 };
            } else {
                return { skill: skill, rowIndex: row, playerIndex: currentIndex };
            }
        }
    }




}

function getHighLightFromteam(teamData) {
    let playerPosition = {};
    find(orderToScan, (position) => {
        find(teamData[position], (player, index) => {
            if (player.isHighlighted === true) {
                // playerPosition = { skill: player.skill, rowIndex: position, playerIndex: index };
                playerPosition = { skill: player.skill, rowIndex: position, playerIndex: index };
            }

        });
    });
    return playerPosition;
}

export function setHighlight(teamData, objKey, playerIndex, lastSkill) {
    updatePropInTeam(teamData, 'isHighlighted', false);
    if (playerIndex != null) {
        teamData[objKey][playerIndex].isHighlighted = true;
        const skill = teamData[objKey][playerIndex].skill;
        teamData.highlightedSkill = { skill: skill, rowIndex: objKey, playerIndex: playerIndex };
    } else {

        teamData.highlightedSkill = { skill: lastSkill, rowIndex: null, playerIndex: null };
    }

    return teamData;
}

export function makeCaptain(teamData, objKey, playerIndex, player) {
    if (isUndefined(objKey) || isUndefined(playerIndex)) {
        const playerPosition = getPlayerPosition(player.Id, teamData);
        objKey = playerPosition.rowIndex;
        playerIndex = playerPosition.playerIndex;
        player = playerPosition.player;
    }
    updatePropInTeam(teamData, 'isCaptain', false);
    teamData[objKey][playerIndex].isCaptain = true;
    teamData.captainID = player.id;
    return teamData;
}

export function removeCaptain(teamData, objKey, playerIndex) {
    updatePropInTeam(teamData, 'isCaptain', false);
    teamData.captainID = null;
    return teamData;
}

function updatePropInTeam(teamData, key, value) {
    orderToScan.forEach(position => {
        teamData[position].forEach(player => {
            player[key] = value;
        });
    });
}

export function getPlayerObject(players, plyrId) {
    return find(players, o => +o.Id === +plyrId);
}

export function isValidateByMaxTeamPlayer(teamDataP, objPlayer, jMaxTeamCount) {
    let totalCount = orderToScan.reduce((initialValue, position) => {
        initialValue += filter(teamDataP[position], (playerObj) => playerObj.id && +playerObj.details.TID === +objPlayer.TID).length;
        return initialValue;
    }, 0);
    if (totalCount === (jMaxTeamCount - 1)) {
        return { status: true, state: 'level' };
    } else if (totalCount >= jMaxTeamCount) {
        return { status: false, state: 'exceed' };
    } else {
        return { status: true, state: 'ok' };
    }
}

export function groupBySkill(data) {
    return groupBy(data, 'Skill');
}

export function sortBy(data, key, order = 'DESC', isPlayerRecomendation) {
    let sortableData = data;
    // sortableData = filter(sortableData,item => item.isActive && item);
    if (order === 'DESC') {
        sortableData = sortableData.sort((obj1, obj2) => {
            const valueA = +obj1[key];
            const valueB = +obj2[key];
            if (valueA > valueB) return -1;
            if (valueA < valueB) return 1;
            return 0;
        });
    } else if (order === 'ASC') {
        sortableData = sortableData.sort((obj1, obj2) => {
            const valueA = +obj1[key];
            const valueB = +obj2[key];
            if (valueA < valueB) return -1;
            if (valueA > valueB) return 1;
            return 0;
        });
    }
    let filtereddata = [];

    if (isPlayerRecomendation) {
        sortableData.map(function (player) {
            if (player[key] == "" || player[key] == null || player[key] == undefined || player[key] == "0") {
            } else {
                filtereddata.push(player);
            }
        })
    }


    if (isPlayerRecomendation) {
        sortableData = filtereddata;
    }

    if (key == "playerRecomendationdDefault") {
        sortableData = sortableData;
    }

    return sortableData;
}




export function shuffleArr(arr) {
    for (let i = arr.length - 1; i >= 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        const itemAtIndex = arr[randomIndex];
        arr[randomIndex] = arr[i];
        arr[i] = itemAtIndex;
    }
    return arr;
}

export function autoComplete(data, groupedPlayers, manageTeamRawData) {
    let teamData = clone(data);
    const getFilteredPlayersBySkill = (skill) => {
        return groupedPlayers[skill].filter(item => item.IsActive && !item.RC && item.PStatus === "");//filtering active and red card player
    };
    let errorObj = {};
    const getEmptyPlayerCount = () =>
        orderToScan.reduce((initialValue, position) => {
            initialValue += filter(teamData[position],
                playerObj => playerObj.id === null
            ).length;
            return initialValue;
        }, 0);
    let avgRemainingBudget;
    let sortedPlayer;
    let storedSkillWiseData = {};
    let playerToBeProcessedLater = [];
    const foundPlayers = [];
    orderToScan.forEach(rowIndex => {
        forEach(teamData[rowIndex], (player, playerIndex) => {
            if (player.id === null) {
                const currentSkill = player.skill;
                sortedPlayer = storedSkillWiseData[currentSkill];
                avgRemainingBudget = teamData.budget / getEmptyPlayerCount();
                if (!sortedPlayer) {
                    sortedPlayer = sortBy(shuffleArr(getFilteredPlayersBySkill(currentSkill)), 'Value');
                    storedSkillWiseData[currentSkill] = sortedPlayer;
                }
                const playerToAssign = find(sortedPlayer, player => {
                    return (
                        player.Value <= avgRemainingBudget &&
                        (teamData.playersInTeam.indexOf(player.Id) === -1) &&
                        (foundPlayers.indexOf(+player.Id) === -1) &&
                        teamCountValidation(teamData, playerToBeProcessedLater, player, teamData.max_playerPerTeam)
                    );
                });
                if (playerToAssign) {
                    playerToBeProcessedLater.push({
                        playerToAssign,
                        currentSkill,
                        rowIndex,
                        playerIndex
                    });
                    foundPlayers.push(+playerToAssign.Id);
                } else {
                    errorObj.isAutofillError = true;
                }
            }
        });
    });
    const getEmptyPlayerOfSkill = (teamData, skill) => {
        for (let i = 0, iLen = orderToScan.length; i < iLen; i++) {
            const skillIndex = orderToScan[i];
            for (let playerIndex = 0, jLen = teamData[skillIndex].length; playerIndex < jLen; playerIndex++) {
                const playerObj = teamData[skillIndex][playerIndex];
                if (playerObj.id === null && +playerObj.skill === +skill) {
                    return { playerObj, skillIndex, playerIndex };
                }
            }
        }
        return {};
    };
    const isPlayerInRemovedKey = (playerID) => {
        return (manageTeamRawData.playersInTeam || []).indexOf(playerID) > -1;
    };
    forEach(playerToBeProcessedLater, player => {
        const { playerToAssign, currentSkill } = player;
        const foundPlayer = getEmptyPlayerOfSkill(teamData, currentSkill);
        if (!isEmpty(foundPlayer)) {
            const { skillIndex, playerIndex } = foundPlayer;
            const playerID = playerToAssign.Id;
            teamData.budget = (+teamData.budget - +playerToAssign.Value).toFixed(1);
            let wasCaptain = teamData[skillIndex][playerIndex].isCaptain;
            const playerObjFound = teamData[skillIndex][playerIndex];
            playerObjFound.id = playerID;
            playerObjFound.details = playerToAssign;
            teamData.playerCount += 1;
            teamData.playersInTeam.push(playerID);
            wasCaptain && (teamData.captainID = playerID);
            if (isPlayerInRemovedKey(playerID)) {
                const oldPosition = getPlayerPosition(playerID, manageTeamRawData);
                const oldRowIndex = oldPosition.rowIndex;
                const oldPositionIndex = oldPosition.playerIndex;
                const playerFromOldPosition = clone(teamData[oldRowIndex][oldPositionIndex]);
                const playerFromNewPosition = clone(teamData[skillIndex][playerIndex]);
                /*Assigning player from old position to new position*/
                teamData[skillIndex][playerIndex].id = playerFromOldPosition.id;
                teamData[skillIndex][playerIndex].details = clone(playerFromOldPosition.details);
                /*Assigning player from new position to old position*/
                teamData[oldRowIndex][oldPositionIndex].id = playerFromNewPosition.id;
                teamData[oldRowIndex][oldPositionIndex].details = clone(playerFromNewPosition.details);
            }
        }
    });
    return { teamData, errorObj };

    function teamCountValidation(teamDataP, playerToBeProcessedLater, objPlayer, jMaxTeamCount) {
        let totalCount = orderToScan.reduce((initialValue, position) => {
            initialValue += filter(teamDataP[position],
                playerObj => {
                    return playerObj.id && +playerObj.details.TID === +objPlayer.TID
                }
            ).length;
            return initialValue;
        }, 0);
        forEach(playerToBeProcessedLater, (player) => {
            if (+player.playerToAssign.TID === +objPlayer.TID) {
                ++totalCount;
            }
        });
        return totalCount < jMaxTeamCount;
    }
}

export function isPlayerInTeam(playerID, teamData) {
    if (teamData && teamData.playersInTeam) {
        return teamData.playersInTeam.indexOf(playerID) > -1
    } else {
        return false;
    }

}

export function isPlayerInBench(playerID, teamData) {
    return some(teamData['0'], (player) => {
        return +player.id === +playerID;
    });
}

export function isCaptain(playerID, teamData) {
    return playerID === teamData.captainID;
}

export function getHighlightedPlayerPosition(teamData) {
    find(orderToScan, (position) => {
        find(teamData[position], (player, index) => {
            if (player.isHighlighted === true) {
                // playerPosition = { skill: player.skill, rowIndex: position, playerIndex: index };
                return { skill: player.skill, rowIndex: position, playerIndex: index };
            }

        });
    });

}

export function getPlayerPosition(playerID, teamData) {
    let playerPosition = {};
    find(orderToScan, (position) => {
        return find(teamData[position], (player, index) => {
            if (+player.details.Id === +playerID) {
                playerPosition = { skill: player.skill, rowIndex: position, playerIndex: index, player };
                return true;
            }
            return false;
        });
    });
    return playerPosition;
}

export function setBadge(data, badgeID) {
    const teamData = clone(data);
    teamData.badgeID = badgeID;
    return teamData;
}

export function setTeamName(data, teamName) {
    const teamData = clone(data);
    teamData.teamName = teamName;
    return teamData;
}

export function setClubID(data, clubID) {
    const teamData = clone(data);
    teamData.clubID = clubID;
    return teamData;
}

export function getFixtureStatus(fixture) {
    let { GDIsLckd, GDIsCurr, MdIsLckd, MdIsCurr, IsActNewUsr } = fixture;
    GDIsLckd = +GDIsLckd;
    GDIsCurr = +GDIsCurr;
    MdIsLckd = +MdIsLckd;
    MdIsCurr = +MdIsCurr;
    IsActNewUsr = +IsActNewUsr;
    switch (true) {
        case (GDIsLckd === 0 && GDIsCurr === 0 && MdIsLckd === 0 && MdIsCurr === 0 && IsActNewUsr === 1): {
            return config.fixtureStatus.isNewUser;
        }
        case (GDIsLckd === 0 && GDIsCurr === 0 && MdIsLckd === 0 && MdIsCurr === 0): {
            return config.fixtureStatus.isUpComing;
        }
        case (GDIsLckd === 1 && GDIsCurr === 1 && MdIsLckd === 1 && MdIsCurr === 1): {
            return config.fixtureStatus.isLock;
        }
        case (GDIsLckd === 1 && GDIsCurr === 1 && MdIsLckd === 0 && MdIsCurr === 1): {
            return config.fixtureStatus.isSubstitution;
        }
        case (GDIsLckd === 1 && GDIsCurr === 2 && MdIsLckd === 1 && MdIsCurr === 2): {
            return config.fixtureStatus.isFinished;
        }
        case (GDIsLckd === 0 && GDIsCurr === 1 && MdIsLckd === 0 && MdIsCurr === 1): {
            return config.fixtureStatus.isOpen;
        }
        default: {
            return config.fixtureStatus.isUpComing;
        }
    }
}

export function getFixturesToPrint(rawFixtures, userPlayerMatchDays) {
    const fixtures = clone(rawFixtures);
    let fixturesWithStatus = addFixturesStatus(fixtures);
    fixturesWithStatus = filter(fixturesWithStatus, fixture => {
        return findIndex(userPlayerMatchDays, { GamedayId: fixture['GDID'] }) > -1;
    });
    const openFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isOpen);
    const lockedFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isLock);
    const substitutionFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isSubstitution);
    const newUserFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isNewUser);
    const finishedFixture = findLast(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isFinished);
    if (openFixture) {
        openFixture.selected = true;
    } else if (lockedFixture) {
        lockedFixture.selected = true;
    } else if (substitutionFixture) {
        substitutionFixture.selected = true;
    } else if (newUserFixture) {
        newUserFixture.selected = true;
    } else if (finishedFixture) {
        finishedFixture.selected = true;
    }
    return fixturesWithStatus;
}

export function getFixturesToPrintForMatches(rawFixtures) {
    const fixtures = clone(rawFixtures);
    let fixturesWithStatus = addFixturesStatus(fixtures);
    const lockedFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isLock);
    const substitutionFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isSubstitution);
    const openFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isOpen);
    const upcomingFixture = find(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isUpComing);
    const finishedFixture = findLast(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isFinished);
    const newUserFixture = findLast(fixturesWithStatus, fixture => fixture.status === config.fixtureStatus.isNewUser);

    let cookieGM = common.getCookie(config.COOKIE_GM);
    let parsedCookie = null;
    if (cookieGM) {
        parsedCookie = common.parseCookie(cookieGM)
    }

    if (newUserFixture && (!parsedCookie || (parsedCookie && !parsedCookie.HasTeam))) {
        newUserFixture.selected = true;
    }
    else {
        if (lockedFixture) {
            lockedFixture.selected = true;
        } else if (substitutionFixture) {
            substitutionFixture.selected = true;
        } else if (openFixture) {
            openFixture.selected = true;
        } else if (upcomingFixture) {
            upcomingFixture.selected = true;
        } else if (finishedFixture) {
            finishedFixture.selected = true;
        }
    }


    return fixturesWithStatus;
}

export function getState(selectedFixture) {
    let jStatus = getFixtureStatus(selectedFixture);
    if (jStatus === config.fixtureStatus.isOpen) {
        return config.possibleActions.subsAndTransfer;
    } else if (jStatus === config.fixtureStatus.isNewUser) {
        return config.possibleActions.subsAndTransfer;
    } else if (jStatus === config.fixtureStatus.isSubstitution) {
        return config.possibleActions.substitution;
    } else if (jStatus === config.fixtureStatus.isLock) {
        return config.possibleActions.live;
    } else if (jStatus === config.fixtureStatus.isFinished) {
        return config.possibleActions.viewpoint;
    }
}

export function addFixturesStatus(rawFixtures) {
    const fixtures = clone(rawFixtures);
    forEach(fixtures, fixture => {
        fixture.status = getFixtureStatus(fixture);
    });
    return fixtures;
}

export function getOrderedPlayerIDs(teamData) {
    return orderToScan.reduce((accumulator, key) => {
        const plainIDs = teamData[key].map(player => player.id);
        return accumulator.concat(plainIDs);
    }, []);
}

function getValidPlayersCountPerSkill(teamData, skill) {
    let count = 0;
    for (let i = 0, iLen = orderToScan.length; i < iLen; i++) {
        let skillIndex = orderToScan[i];
        for (let j = 0, jLen = teamData[skillIndex].length; j < jLen; j++) {
            const foundJersey = teamData[skillIndex][j];
            if (+foundJersey.skill === +skill && canPlayerSubstitute(foundJersey)) {
                ++count;
            }
        }
    }
    return count;
}

export function makeManageTeamSkeleton(rawTeamFromDB, players, formations) {
    const rawPlayers = rawTeamFromDB.Players;
    let manageTeamData = {}, playerCount = 0, playersInTeam = [];
    let captainID = null;
    const mapDBPlayer = (player, skill) => {
        const playerID = player.Id.toString();
        ++playerCount;
        playersInTeam.push(playerID);
        let details = find(players, (playerFromListing) => +playerFromListing.Id === +playerID);
        const DBDetails = merge(details, clone(player));
        DBDetails.Id = playerID;
        const isCaptain = +player['IsCaptain'] === 1;
        if (isCaptain) {
            captainID = playerID;
        }
        return {
            id: playerID,
            DBDetails,
            details,
            isCaptain: isCaptain,
            isHighlighted: false,
            skill: player['Skill'],
            isBench: +skill === 0
        }
    };
    orderToScan.forEach((skill) => {
        let filterHandler = (player) => {
            return player['BenchPosition'] === 0 && player['Skill'] === +skill;
        };
        if (skill === '0') {
            filterHandler = (player) => {
                return player['BenchPosition'] > 0;
            }
        }
        let playersOfThatSkill = filter(rawPlayers, filterHandler);
        if (skill === '0') {
            playersOfThatSkill = sortBy(playersOfThatSkill, 'BenchPosition', 'ASC');
        }
        manageTeamData[skill] = playersOfThatSkill.map((player) => {
            return mapDBPlayer(player, skill);
        });
    });
    let maxFormation = find(formations, formation => +formation.CompId === +config.MAX_FORMATION_COMP_ID);
    manageTeamData.maxPos = [
        maxFormation['GK'],
        maxFormation['DEF'],
        maxFormation['MID'],
        maxFormation['FWD']
    ];
    let clonedRawTeamFromDB = clone(rawTeamFromDB);
    delete clonedRawTeamFromDB.Players;
    const { MaxTeamPlayers } = clonedRawTeamFromDB;
    manageTeamData.max_playerPerTeam = MaxTeamPlayers;
    manageTeamData.budget = rawTeamFromDB['TeamBalance'];
    manageTeamData.playerCount = playerCount;
    manageTeamData.playersInTeam = playersInTeam;
    manageTeamData.captainID = captainID;
    manageTeamData = merge(manageTeamData, clonedRawTeamFromDB);
    const fwd = getValidPlayersCountPerSkill(manageTeamData, config.EnumPosition.Forwards);
    const mid = getValidPlayersCountPerSkill(manageTeamData, config.EnumPosition.Midfielders);
    const def = getValidPlayersCountPerSkill(manageTeamData, config.EnumPosition.Defenders);
    const updatedFormations = formations.map(formation => {
        formation.IsActive = formation.FWD <= fwd && formation.MID <= mid && formation.DEF <= def;
        return formation;
    });
    return { teamData: manageTeamData, updatedFormations };
}

export function getInTeamArray(teamData, oldTeamData) {
    let diff = [];
    const areBothDataSameInSkeleton = every(orderToScan, (i) => {
        return (oldTeamData[i] && teamData[i] && oldTeamData[i].length === teamData[i].length)
    });
    if (areBothDataSameInSkeleton) {
        forEach(orderToScan, (skillIndex) => {
            const difference = filter(teamData[skillIndex], (player, index) => {
                return +player.id !== +oldTeamData[skillIndex][index].id;
            });
            let currDiff = filter(difference, (player) => player.id !== null);
            if (currDiff.length) diff = diff.concat(currDiff);
        });
    }

    // const isCaptainInBench = (teamData) => {
    //     return teamData[0].some(el => el.isCaptain === true);
    // };
    // if (isCaptainInBench) {
    //     // alert();
    //     if (1) {

    //     }
    // }

    return diff;
}

export function getOutTeamArray(teamData, oldTeamData) {
    let diff = [];
    const areBothDataSameInSkeleton = every(orderToScan, (i) => {
        return (oldTeamData[i] && teamData[i] && oldTeamData[i].length === teamData[i].length)
    });
    if (areBothDataSameInSkeleton) {
        forEach(orderToScan, (skillIndex) => {
            const difference = filter(oldTeamData[skillIndex], (player, index) => {
                return +player.id !== +teamData[skillIndex][index].id;
            });
            let currDiff = filter(difference, (player) => player.id !== null);
            if (currDiff.length) diff = diff.concat(currDiff);
        });
    }
    return diff;
}

export function resetSubstitution(teamData) {
    orderToScan.forEach(position => {
        teamData[position].forEach(player => {
            delete player.couldBeUsedToReplace;
            delete player.toBeSubstituted;
            delete player.substituted;
        });
    });
}

export function cancelSubstitution(teamDataRaw) {
    const teamData = clone(teamDataRaw);
    orderToScan.forEach(position => {
        teamData[position].forEach(player => {
            delete player.couldBeUsedToReplace;
            delete player.toBeSubstituted;
        });
    });
    delete teamData.substitutionInitiated;
    return teamData;
}

export function canMovePlayer(arrSelectedPlayer, dragObject, dropObject, dragRowIndex, dragColumnIndex, jSkillFormationLengthDrop) {
    let dragId = +dragObject.id,
        dragSkillId = +dragObject.skill,
        isDragBench = dragObject.isBench,
        dropId = +dropObject.id,
        dropSkillId = +dropObject.skill,
        isDropBench = dropObject.isBench;
    let fResp = false;
    //goal keeper only
    if (dropId !== config.emptyValue && dragId !== dropId) {
        if (+dragSkillId === +config.EnumPosition.Goalkeepers && +dragSkillId === +dropSkillId) {
            fResp = true;
            let objPlayer = dropObject.details;
            if (objPlayer && objPlayer.id !== config.emptyValue) {
                if (isDropBench && +objPlayer.IsPlayed) {
                    fResp = false;
                }
                if (+objPlayer.IsRedCard) {
                    fResp = false;
                }
            }
        }
        else if (dragSkillId !== config.EnumPosition.Goalkeepers && dropSkillId !== config.EnumPosition.Goalkeepers) {
            if (isDragBench) {//drop = bench
                let flag = false;
                let jMinLength = config.EnumMinPositionNos[dropSkillId];
                if (jMinLength < jSkillFormationLengthDrop) {
                    flag = true;
                }
                if (isDropBench || +dragSkillId === +dropSkillId || flag) {
                    fResp = true;
                    //if it is GDExists.
                    let objPlayer = dropObject.details;
                    if (objPlayer && objPlayer.id !== config.emptyValue) {
                        if (isDropBench && +objPlayer.IsPlayed) {
                            fResp = false;
                        }
                        if (+objPlayer.IsRedCard) {
                            fResp = false;
                        }
                    }
                }
            }
            else if (!isDragBench) {//drag from player
                let flag = false;
                let jMaxLength = config.EnumMaxPositionNosBench[dragSkillId];
                let jMaxLengthBench = 0;
                let cellData = arrSelectedPlayer[dragRowIndex][dragColumnIndex];
                let rowDataBench = arrSelectedPlayer['0'];
                if (cellData) {

                    //check count in bench
                    for (let jNdex = 0; jNdex < (rowDataBench || []).length; jNdex++) {
                        let row = rowDataBench[jNdex];
                        if (+row.skill === +cellData.skill) {
                            jMaxLengthBench = jMaxLengthBench + 1;
                        }
                    }
                }
                if ((jMaxLength !== jMaxLengthBench && ((dragSkillId !== dropSkillId) || (+dragSkillId === +dropSkillId))) || (+jMaxLength === +jMaxLengthBench && +dragSkillId === +dropSkillId)) {
                    flag = true;
                }
                if (isDropBench && flag) {
                    fResp = true;
                }
                //if it is GDExists.
                let objPlayer = dropObject.details;
                if (objPlayer && objPlayer.id !== config.emptyValue) {
                    if (+objPlayer.IsPlayed) {
                        fResp = false;
                    }
                    if (+objPlayer.IsRedCard) {
                        fResp = false;
                    }
                }
            }
        }
    }
    return fResp;
}

export function getPlayerByKeyFromTeamData(teamData, key, value) {
    let playerData = {};
    find(orderToScan, (position) => {
        return find(teamData[position], (player, index) => {
            if (player[key] === value) {
                playerData = { skill: player.skill, rowIndex: position, playerIndex: index, data: player };
                return true;
            }
            return false;
        });
    });
    return playerData;
}

function addSubstitutedKey(teamData, manageTeamRawData) {
    const isPlayerInBench = (passedTeamData, playerID) => {
        return some(passedTeamData['0'], (player) => {
            return +player.id === +playerID;
        });
    };
    orderToScan.forEach((skillIndex) => {
        if (skillIndex !== '0') {
            teamData[skillIndex].forEach((player) => {
                const status = isPlayerInBench(manageTeamRawData, player.id);
                if (status === true) {
                    player.substituted = true;
                }
            });
        }
    });
    teamData['0'].forEach((player, index) => {
        const foundIndex = findIndex(manageTeamRawData['0'], (oldPlayer) => {
            return +oldPlayer.id === +player.id;
        });
        if (foundIndex === -1) {
            player.substituted = true;
        } else if (foundIndex !== index) {
            player.substituted = true;
        }
    });
    return teamData;
}

export function substituteThisPlayer(teamDataRaw, playerData) {
    const teamData = clone(teamDataRaw);
    cancelSubstitution(teamData);
    const playerPosition = getPlayerPosition(playerData.id, teamData);
    const { rowIndex, playerIndex } = playerPosition;
    /*To set `toBeGoingOut` or `toBeGoingIn` based on bench position */
    orderToScan.some((key) => {
        return teamData[key].some((player) => {
            if (+player.id === +playerData.id) {
                player['toBeSubstituted'] = true;
                return true;
            }
            return false;
        });
    });
    forEach(orderToScan, (skillKey) => {
        forEach(teamData[skillKey], (playerObj) => {
            const lenOfSkill = teamData[playerObj.skill].length;
            const canMove = canMovePlayer(teamData, playerData, playerObj, rowIndex, playerIndex, lenOfSkill);
            if (canMove) {
                playerObj.couldBeUsedToReplace = true;
            }
        });
    });
    teamData.substitutionInitiated = true;
    teamData.IsBenchSubstitution = playerData.isBench;
    delete teamData.substitutionCompleted;
    return teamData;
}

export function replaceWithThisPlayer(teamDataRaw, manageTeamRawData, playerData) {
    const teamData = clone(teamDataRaw);
    const toBeSubstitutedPlayer = getPlayerByKeyFromTeamData(teamData, 'toBeSubstituted', true);
    const toBeReplacedPlayer = getPlayerByKeyFromTeamData(teamData, 'id', playerData.id);
    const toBeSubSkill = toBeSubstitutedPlayer.skill;
    const toBeReplacedSkill = playerData.skill;
    const areBothFromBench = toBeReplacedPlayer.data.isBench === true && toBeSubstitutedPlayer.data.isBench === true;
    if ((toBeSubSkill === toBeReplacedSkill) || areBothFromBench) {
        const { rowIndex, playerIndex } = toBeSubstitutedPlayer;
        const skillIdentifierOfToBeReplaced = toBeReplacedPlayer.rowIndex;
        const positionIndexOfToBeReplaced = toBeReplacedPlayer.playerIndex;
        if (!areBothFromBench)/*If both are fro bench, ignore captain case*/ {
            if (toBeSubstitutedPlayer.data.isBench) {/*Player is in bench and now will be in team*/
                toBeSubstitutedPlayer.data.isCaptain = toBeReplacedPlayer.data.isCaptain;
                toBeReplacedPlayer.data.isCaptain = false;
            }
            if (toBeReplacedPlayer.data.isBench) {/*Player is in bench and now will be in team*/
                toBeReplacedPlayer.data.isCaptain = toBeSubstitutedPlayer.data.isCaptain;
                toBeSubstitutedPlayer.data.isCaptain = false;
            }
        }
        teamData[skillIdentifierOfToBeReplaced][positionIndexOfToBeReplaced]
            = clone({ ...toBeSubstitutedPlayer.data, isBench: +skillIdentifierOfToBeReplaced === 0 });
        teamData[rowIndex][playerIndex] = clone({ ...toBeReplacedPlayer.data, isBench: +rowIndex === 0 });
    } else {
        let whoIsFromBench = toBeReplacedPlayer.data.isBench ? 'toBeReplacedPlayer' : 'toBeSubstitutedPlayer';
        const skillIdentifierOfToBeReplaced = toBeReplacedPlayer.rowIndex;
        const positionIndexOfToBeReplaced = toBeReplacedPlayer.playerIndex;
        const skillOfToBeReplaced = toBeReplacedPlayer.skill;
        const skillIdentifierOfToBeSubstituted = toBeSubstitutedPlayer.rowIndex;
        const positionIndexOfToBeSubstituted = toBeSubstitutedPlayer.playerIndex;
        const skillOfToBeSubstituted = toBeSubstitutedPlayer.skill;
        if (toBeSubstitutedPlayer.data.isBench) {/*Player is in bench and now will be in team*/
            toBeSubstitutedPlayer.data.isCaptain = toBeReplacedPlayer.data.isCaptain;
            toBeReplacedPlayer.data.isCaptain = false;
        }
        if (toBeReplacedPlayer.data.isBench) {/*Player is in bench and now will be in team*/
            toBeReplacedPlayer.data.isCaptain = toBeSubstitutedPlayer.data.isCaptain;
            toBeSubstitutedPlayer.data.isCaptain = false;
        }
        if (whoIsFromBench === 'toBeReplacedPlayer') {
            teamData[skillIdentifierOfToBeReplaced][positionIndexOfToBeReplaced]
                = clone({ ...toBeSubstitutedPlayer.data, isBench: +skillIdentifierOfToBeReplaced === 0 });
            teamData[skillOfToBeReplaced].push(clone({
                ...toBeReplacedPlayer.data,
                isBench: +skillOfToBeReplaced === 0
            }));
            teamData[skillIdentifierOfToBeSubstituted].splice(positionIndexOfToBeSubstituted, 1);
        } else {
            teamData[skillIdentifierOfToBeSubstituted][positionIndexOfToBeSubstituted]
                = clone({ ...toBeReplacedPlayer.data, isBench: +skillIdentifierOfToBeSubstituted === 0 });
            teamData[skillOfToBeSubstituted].push(clone({
                ...toBeSubstitutedPlayer.data,
                isBench: +skillOfToBeSubstituted === 0
            }));
            teamData[skillIdentifierOfToBeReplaced].splice(positionIndexOfToBeReplaced, 1);
        }
    }
    resetSubstitution(teamData);
    addSubstitutedKey(teamData, manageTeamRawData);
    const captainObj = getPlayerByKeyFromTeamData(teamData, 'isCaptain', true);
    teamData.captainID = (captainObj && captainObj.data) ? captainObj.data.id : teamData.captainID;
    delete teamData.substitutionInitiated;
    teamData.substitutionCompleted = true;
    return teamData;
}

export function getTransfersApiData(oldTeamData, newTeamData) {
    let data = {
        InPlayerId: [],
        InPlayerBenchPosition: [],
        OutPlayerId: [],
        OutPlayerBenchPosition: []
    };
    forEach(orderToScan, (skillIndex) => {
        forEach(oldTeamData[skillIndex], (player, index) => {
            const newPlayerID = newTeamData[skillIndex][index].id;
            if (player.id !== newPlayerID) {
                data.InPlayerId.push(newPlayerID);
                const inPlayerBenchPosition = +skillIndex !== 0 ? 0 : (index + 1);
                data.InPlayerBenchPosition.push(inPlayerBenchPosition);
                data.OutPlayerId.push(player.id);
                data.OutPlayerBenchPosition.push(inPlayerBenchPosition);
            }
        });
    });
    return data;
}

export function getSubstitutionStatus(oldTeamData, newTeamData) {
    let response = { count: 0, substituted: false };
    const diff = filter(oldTeamData['0'], player => {
        const isPlayerNotInBench = (playerID, otherBench) => {
            return find(otherBench, (benchPlayer) => {
                return +benchPlayer.id === +playerID;
            });
        };
        return !isPlayerNotInBench(player.id, newTeamData['0']);
    });
    if (diff.length === 0) {
        response.substituted = some(oldTeamData['0'], (player, index) => {
            return (player.id !== newTeamData['0'][index].id)
        });
    } else {
        response.count = diff.length;
        response.substituted = true;
    }
    return response;
}

export function getAutoSubstitutionsApiData(teamDataRaw, rawTeamData) {
    const teamData = clone(teamDataRaw);
    const isPlayerSubstituted = (oldTeamData, index, playerId) => {
        return some(oldTeamData[index], player => {
            return +player.id === +playerId;
        });
    };
    orderToScan.forEach((skillIndex) => {
        if (skillIndex !== '0') {
            teamData[skillIndex].forEach((player, index) => {
                const { id } = player;
                const playerNotSubstituted = isPlayerSubstituted(rawTeamData, skillIndex, id);
                if (!playerNotSubstituted) {
                    player.substituted = true;
                }
            });
        }
    });
    teamData['0'].forEach((player, index) => {
        const { id } = player;
        if (rawTeamData['0'][index].id !== id) {
            player.substituted = true;
        }
    });
    return teamData;
}

export function getSubstitutionsApiData(teamData) {
    let data = {
        SubPlayerId: [],
        SubPlayerBenchPosition: [],
        showConfirmation: false
    };
    orderToScan.forEach((skillIndex) => {
        teamData[skillIndex].forEach((player, index) => {
            if (player.substituted === true) {
                data.SubPlayerId.push(player.id);
                data.SubPlayerBenchPosition.push(player.isBench ? (index + 1) : 0);
                let OverallPoints = (player.DBDetails ? player.DBDetails.OverallPoints : 0)
                if (!data.showConfirmation && OverallPoints != 0 && OverallPoints != undefined && OverallPoints != null) {
                    data.showConfirmation = true
                }
            }
        });
    });
    return data;
}

export function resetAll(teamDataRaw) {
    const teamData = clone(teamDataRaw);
    const removePlayer = (teamData, skillIdentifier, positionIndex) => {
        teamData.budget = +teamData.budget + (+teamData[skillIdentifier][positionIndex].details.Value || 0);
        let wasCaptain = teamData[skillIdentifier][positionIndex].isCaptain;
        const playerObjFound = teamData[skillIdentifier][positionIndex];
        playerObjFound.id = null;
        playerObjFound.details = {};
        teamData.playerCount -= 1;
        const playerIndex = teamData.playersInTeam.indexOf(playerObjFound.id);
        teamData.playersInTeam.splice(playerIndex, 1);
        updatePropInTeam(teamData, 'isHighlighted', false);
        wasCaptain && (teamData.captainID = null);
        teamData.highlightedSkill = getNextPositionToHighlight(teamData, skillIdentifier, positionIndex);
    };
    orderToScan.forEach((skillIndex) => {
        teamData[skillIndex].forEach((player, index) => {
            removePlayer(teamData, skillIndex, index);
        });
    });
    return teamData;
}

export function getPlayerDBDetails(playerID, teamData) {
    let DBDetails = {};
    find(orderToScan, (position) => {
        return find(teamData[position], (player, index) => {
            if (+player.details.Id === +playerID) {
                return player.DBDetails;
            }
        });
    });
    return DBDetails;
}

export function canPlayerSubstitute(player) {
    const { DBDetails } = player;
    const IsPlayed = +DBDetails.IsPlayed === 1;
    const isBench = DBDetails['BenchPosition'] > 0;
    const RC = DBDetails['IsRedCard'] === 1;
    if (isBench && IsPlayed) {
        return false;
    }
    return !RC;
}

export const getPlayerInfoIfFound = (playerID, liveData) => {
    let stats = {}, statsFound = false, points = {}, pointsFound = false;
    for (let i = 0, iLen = liveData.length; i < iLen; i++) {
        for (let j = 0, jLen = liveData[i]['PStats'].length; j < jLen; j++) {
            if (+liveData[i]['PStats'][j].PID === +playerID) {
                stats = liveData[i]['PStats'][j];
                statsFound = true;
                break;
            }
        }
        for (let j = 0, jLen = liveData[i]['PPoints'].length; j < jLen; j++) {
            if (+liveData[i]['PPoints'][j].PID === +playerID) {
                points = liveData[i]['PPoints'][j];
                pointsFound = true;
                break;
            }
        }
        if (statsFound && pointsFound) {
            break;
        }
    }
    return { stats, points };
};

export function getLivePlayersData(teamData, liveData) {
    let total = 0;
    forEach(orderToScan, (skillIndex) => {
        forEach(teamData[skillIndex], (player) => {
            let { stats, points } = getPlayerInfoIfFound(player.id, liveData);
            points = clone(points);
            const { DBDetails } = player;
            let pointsToConsider = 0;


            if (DBDetails) {
                if (!isEmpty(points)) {
                    points.TPoints = +(points.TPoints || 0);
                    if (+DBDetails.BenchPosition === 0) {
                        if (+DBDetails.IsCaptain === 1) {
                            points.TPoints *= 2;
                        }
                        pointsToConsider = points.TPoints;
                    }
                }
                if (!size(points) && !size(stats) && +DBDetails.BenchPosition === 0 && +DBDetails.OverallPoints) {
                    pointsToConsider = +DBDetails.OverallPoints
                }

            } else {
                if (player && player.details && player.details.TotPts) {
                    pointsToConsider = player.details.TotPts;
                }
            }



            player.stats = stats;
            player.points = points;
            total += pointsToConsider;
        });
    });
    teamData.totalLivePoints = total;
    return teamData;
}

export function getLiveScoreLine(MID, liveData = []) {
    const obj = {};
    for (let i = 0, iLen = liveData.length; i < iLen; i++) {
        if (+liveData[i].MID === +MID && (+liveData[i].Status === config.liveFeedStatus.live || +liveData[i].Status === config.liveFeedStatus.finished)) {
            const scoreLine = liveData[i].ScoreLine || [];
            if (scoreLine.length) {
                obj[scoreLine[0].TID] = scoreLine[0].GS;
                obj[scoreLine[1].TID] = scoreLine[1].GS;
                obj['MatchMinute'] = liveData[i]['MatchMinute'];
                obj['Status'] = liveData[i]['Status'];
                break;
            }
        }
    }
    return obj;
}

export function getPlayingPlayers(arrPlayers, liveScore) {
    return filter(arrPlayers, (player) => {
        const { stats, points } = getPlayerInfoIfFound(player.PlayerId, liveScore);
        player.stats = stats;
        player.points = points;
        return !isEmpty(points);
    });
}

export function findMatchEndMode(liveFeed, fixturesLen) {
    var allMatchPost = liveFeed.every(item => item.Status === 1)
    if (liveFeed.length == fixturesLen && allMatchPost) {
        return true
    }
}


// WEBPACK FOOTER //
// ./src/helper.js